import { createBrowserRouter } from 'react-router-dom';
import Layout from '../layouts/MainLayout';
import Home from '../pages/Home';
import UploadProcess from '../pages/UploadProcess';
import AuditNode from '../pages/AuditNode';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <Home />,
        },
        {
          path: '/upload-process',
          element: <UploadProcess />,
        },
        {
          path: '/audit-node',
          element: <AuditNode />,
        },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
    },
  }
);

export default router; 